
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruiter-faqs",
      function () {
        return require("private-next-pages/recruiter-faqs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruiter-faqs"])
      });
    }
  